module.exports = __webpack_public_path__ + "img/1495593924.208f6821.jpg";